import React from "react";
import { PlanType } from "../../components/enums/plan-type";
import HealthPlan from "../../components/health-plan";

const Vision = ({ pageStep }) => {

  return (
    <HealthPlan pageStep={pageStep} defaultPlanId="VIS" defaultPlanDescription="Vision" waivedOption="0" planType={PlanType.Vision} />
  );
};

export default Vision;
